import { render, staticRenderFns } from "./HistoryOfChanges.vue?vue&type=template&id=72b8f047"
import script from "./HistoryOfChanges.vue?vue&type=script&lang=js"
export * from "./HistoryOfChanges.vue?vue&type=script&lang=js"
import style0 from "./HistoryOfChanges.vue?vue&type=style&index=0&id=72b8f047&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports